@if (_active) {
  <kendo-window title="{{'Edit Record' }}" (close)="_closeForm()" (stateChange)="_onStateChanges($event)"
    class="adminBarcodeLAbelPrint">
    <form novalidate [formGroup]="" class="form_style">
      <div class="row enterpsriseRowStyle margin_top_8">
        <div class="col-12">
          <div class="mainBarcodeLabelPrintContainer">
            <div class="row">
              <div class="k-block noborder_buttom">
                <h2>Barcode Label Print Preferences</h2>
                <div class="right_buttons">
                  <br />
                  <div class="row bottom_buttons">
                    <div class="col-xs-12">
                      <button (click)="_onSave()" kendoButton>
                        <span>
                          <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" />
                        </span>Save
                      </button>
                      <button kendoButton (click)="_onCancel()">
                        <span>
                          <img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" />
                          </span><span>Close</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="borderSeperator"> </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group special_style_formgroup">
                        <label class="control-label">Form Name</label>
                        <asap-barcode-generation [disabled]="true"
                          [(ngModel)]="_selectedFormName"
                          [ngModelOptions]="{standalone: true}"
                          required
                          readonly>
                        </asap-barcode-generation>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group special_style_formgroup">
                        <label for="itemType" class="control-label">Label Type</label>
                        <kendo-combobox [data]="_labelPreset"
                          textField="name"
                          valueField="id"
                          [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="_selectdLabelPreset"
                          required [placeholder]="'Select Label Type'">
                        </kendo-combobox>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group special_style_formgroup">
                        <label for="itemType" class="control-label">Label Size</label>
                        <kendo-combobox [data]="_labelSize"
                          textField="name"
                          valueField="id"
                          [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="_selectedLabelSize"
                          required [placeholder]="'Select Label Size'">
                        </kendo-combobox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </kendo-window>
  }
